
<div>
    <ejs-toolbar #primaryToolbar>
        <e-items>
            <e-item id="redact-blackout-button" text="Black Out" (click)="redactBlackOut()"></e-item>
            <e-item id="redact-whiteout-button" text="White Out" (click)="redactWhiteOut()"></e-item>
            <e-item type="Separator"></e-item>
            <e-item id="apply-redaction-button"text="Apply Redaction" (click)="applyRedaction()"></e-item>
            <e-item type="Separator"></e-item>
            <e-item id="stamp-dropdown-button" type="Button" [template]="stampDropDownButtons"></e-item>
            <e-item type="Separator"></e-item>
            <e-item id="apply-redaction-button"text="Apply Stamp" (click)="applyStamp()"></e-item>
        </e-items>

    </ejs-toolbar>
</div>

<div>
    <ejs-pdfviewer 
        #pdfviewer id="pdfviewer"
        [resourceUrl]="resource"
        [toolbarSettings]="toolbarSettings"
        [enableAnnotationToolbar]="true"
        [enableCommentPanel]="false"
        (documentLoad)="pdfDocumentLoaded($event)"
        (annotationAdd)="annotationAdd($event)"
        (annotationRemove)="annotationRemove($event)"
        style="height:640px; display:block">

    </ejs-pdfviewer>
</div>

<ng-template #stampDropDownButtons>
    <button #stampDropDown 
        id="stamp-dropdown" 
        ejs-dropdownbutton 
        [items]='stampsDropdownOptions' 
        content='Stamps' 
        (select)="stampSelect($event)">
    </button>
</ng-template>